import CajaMensualList from './CajaMensualList'
export {CajaMensualList}
export default CajaMensualList
